export function cloneData (obj) {
  const jsonObj = JSON.stringify(obj)
  return JSON.parse(jsonObj)
}



// WEBPACK FOOTER //
// ./src/helpers/object.js